import React, {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import Products from '../ProductCarousal1/Products';
import { useCart } from '../AddToCart/CartContext';
import { useNavigate } from 'react-router-dom';  
import './SearchResults.css';
import CartDrawer from '../AddToCart/CartDrawer';

const SearchResults = () => {
  const { addToCart} = useCart();
  const location = useLocation();

  // State to control the cart drawer visibility
  const [isCartOpen, setIsCartOpen] = useState(false);

  // Function to open the cart drawer
  const handleAddToCart = (item) => {
    addToCart(item); // Add the item to the cart
    setIsCartOpen(true); // Open the cart drawer
  };

  useEffect(() => {
    window.scrollTo(0, 0);
}, []);

  const { query, products } = location.state || { query: '', products: [] };

  const navigate = useNavigate();
  const handleProductClick = (Id) => {
    navigate(`/product_detail/${Id}`); // Navigate to the product detail page with the specific product ID
  };

  return (
    <>
    <div className='search-result-container'>
      <h2 className='search-result-text'>Search Results for "{query}"</h2>
      <ul className="search-result">
          {products.map((item) => (
            <li
              key={item.id}
              onClick={() => handleProductClick(item.id)} 
             >
              <img src={item.imageUrl[0]} alt={item.name} />
              <div>
              <h4 className='search-result-item-name'>{item.title}</h4>
                {/* <h4 className='search-result-item-name'>{item.name}</h4> */}
                {/* <p className='search-result-item-price'> Price: {item.price}</p> */}
                <div>
                {item.discountPrice && item.discountPrice > 0 ? (
                  <>
                    <p className="search-result-item-price">
                      Rs. {item.price}
                    </p>
                    <p className="search-result-item-discount-price">
                      Rs. {item.discountPrice}
                    </p>
                  </>
                ) : (
                      <p className="search-result-item-discount-price">Rs.{item.price}</p>
                    )}
                    </div>
              </div>
              <button
                className="search-result-add-to-cart-button"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent triggering the product click event
                  // addToCart(item); // Add the item to the cart
                  handleAddToCart(item);
                }}
              >
              Add to Cart
              </button>
            </li>
          ))}
      </ul>
      {/* <ul>
            {products.map((item) => (
              <li key={item.id}>
                <Products
                  key={item.id}
                  id={item.id}
                  name={item.name}
                  imageUrl={item.imageUrl}
                  price={item.price}
                  addToCart={addToCart}
                />
              </li>
            ))}
      </ul> */}
    </div>
    {/* Cart Drawer */}
    <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
};

export default SearchResults;
